import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {UserType} from '@enum/user-roles/user-type';

class ShopVendorSellerPermissionClass implements UserPermission {
  readonly userRole = UserRole.SHOP_VENDOR;
  readonly labelRole = 'User';
  readonly isAuthenticated = true;

  readonly canRequestEto = true;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = true;
  readonly canSeeHisAccountInRightDrawer = true;
  readonly canSeeHisAccountPreferences = false;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = true;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = true;
  readonly crmSectionsVisible = [];
  readonly isLabelRoleVisibleInHeader = true;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = false;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = false;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = true;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const ShopVendorSellerPermission = new ShopVendorSellerPermissionClass();

UserPermissionManager.instance.assignPermissionWithCheckingFn(
  ShopVendorSellerPermission,
  ({role, userType}) => role === UserRole.SHOP_VENDOR && userType === UserType.Seller
);
